module.exports = __webpack_public_path__ + "static/img/Galaxy_Watch3.7ae0d694.jpg";